import { Dispatch } from 'redux';
import { getOfflinePromotions } from '../../clients/HrpsPromotionsApi';
import { Logger } from '../../utils/logger';
import { PromotionMap, RootState } from '../types';
import { OFFLINE_PROMOTIONS_CHANGED, PromotionActions } from './promotionActions';

export function getOfflinePromotionsLoading(existingMap?: PromotionMap): PromotionActions {
    return {
        type: OFFLINE_PROMOTIONS_CHANGED,
        payload: { status: 'Loading', value: existingMap },
    };
}

export function getOfflinePromotionsLoaded(promotionMap: PromotionMap): PromotionActions {
    return {
        type: OFFLINE_PROMOTIONS_CHANGED,
        payload: { status: 'Loaded', value: promotionMap },
    };
}

export function getOfflinePromotionsFailed(error: any): PromotionActions {
    return {
        type: OFFLINE_PROMOTIONS_CHANGED,
        payload: { status: 'Failed', error, value: undefined },
    };
}

export function fetchMissingPromotions(resellerId: string, promotionIds: string[]) {
    return (dispatch: Dispatch, getState: () => RootState) => {
        const existing = getState().promotionReducer.offlinePromotions.value;
        const missingIds = promotionIds.filter((id) => id && !existing?.has(id));

        if (missingIds.length === 0) {
            return Promise.resolve();
        }

        dispatch(getOfflinePromotionsLoading(existing));
        return getOfflinePromotions(resellerId, missingIds)
            .then((promotions) => {
                const merged = new Map(existing || []);
                promotions.forEach((p) => merged.set(p.promotionId, p));
                dispatch(getOfflinePromotionsLoaded(merged));
            })
            .catch((error) => {
                Logger.error('Failed to fetch promotions:', error);
                dispatch(getOfflinePromotionsFailed(error));
            });
    };
}
